import React, { useEffect } from 'react';
import { Container } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';
import '../Features.css';

const Icon = () => {
  const { t } = useTranslation();
  useEffect(() => {
    document.getElementById('home').classList.add('featureContent');
    return () => {
      document.getElementById('home').classList.remove('featureContent');
    };
  });
  useEffect(() => {
    setTimeout(() => {
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }, 100);
  }, []);
  return (
    <Container className="featurePages icon">
      <div className="header">
        <div className="headerContent">
          <h2 className="title">{t('contents:iconTitle1')}</h2>
          <p className="text">
            {t('contents:iconParagraph1')}
            <br />
            <br />
            {t('contents:iconParagraph2')}
          </p>
        </div>
        <img src={require('../../../assets/images/features/pages/icon/icon_01.png')} />
      </div>
      <div className="content">
        <div className="container">
          <div className="section section01">
            <div className="textBox">
              <p>
                {t('contents:iconParagraph3')}
                <br />
                <br />
              </p>
            </div>
            <div className="imageBox">
              <img src={require('../../../assets/images/features/pages/icon/icon_04.png')} />
            </div>
          </div>
          <div className="section section02">
            <div className="textBox">
              <h2 className="title">{t('contents:iconTitle2')}</h2>
              <p>{t('contents:iconParagraph4')}</p>
            </div>
            <div className="imageBox">
              <img src={require('../../../assets/images/features/pages/icon/icon_05.png')} />
            </div>
          </div>
          <div className="section section03">
            <div className="textBox">
              <h2 className="title">{t('contents:iconTitle4')}</h2>
              <p>{t('contents:iconParagraph6')}</p>
            </div>
            <div className="imageBox">
              <img src={require('../../../assets/images/features/pages/icon/icon_06.png')} />
            </div>
          </div>
          <div className="section section04">
            <div className="textBox">
              <h2 className="title">{t('contents:iconTitle6')}</h2>
              <p>
                {t('contents:iconParagraph8')}
                <br />
                {t('contents:iconParagraph9')}
              </p>
            </div>
            <div className="imageBox">
              <img src={require('../../../assets/images/features/pages/icon/icon_07.png')} />
            </div>
          </div>
          <div className="section section05">
            <div className="textBox">
              <h2 className="title">{t('contents:iconTitle3')}</h2>
              <p>{t('contents:iconParagraph5')}</p>
            </div>
            <div className="imageBox">
              <img src={require('../../../assets/images/features/pages/icon/icon_08.png')} />
            </div>
          </div>
          <div className="section section06">
            <div className="textBox">
              <h2 className="title">{t('contents:iconTitle5')}</h2>
              <p>{t('contents:iconParagraph7')}</p>
            </div>
            <div className="imageBox">
              <img src={require('../../../assets/images/features/pages/icon/icon_09.png')} />
            </div>
          </div>
        </div>
        <div className="footer"></div>
      </div>
    </Container>
  );
};

export default Icon;
